<template>
    <div id="left-bar-shipping">
        <ul>
            <li class="menu-title text-center">
                <i class="fa fa-truck"></i>
                {{ $t("LeftBarShipping.shipping") }}
            </li>
            <li class="has_sub active">
                <router-link to="/shipping/dashboard" class="waves-effect active">
                    <i class="fa fa-chart-line"></i>
                    <span> {{ $t("LeftBarShipping.dashboard") }} </span>
                </router-link>
            </li>
        </ul>
        <div class="clearfix"></div>
    </div>
</template>

<script>
export default {
    name: "LeftBarShipping",
};
</script>

<style lang="scss">
    @import "../../../assets/scss/colors";

    #left-bar-shipping {
        .waves-effect {
            &.active {
                border-left-color: $shipping-color;
                i {
                    color: $shipping-color;
                }
            }
            .waves-ripple {
                background-color: rgba($shipping-color, 0.45) !important;
            }
        }
    }
</style>